
import { useBoolean } from "@fluentui/react-hooks";
import { useState } from "react";
import { IElementoEstandarDTO } from "../../../../Interfaces/hazard/IHazard";
import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import IconHelper from "../../../../utils/helpers/iconHelper";
import themeBase from "../../../../utils/theme/themeBase";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { UseElementosEstandarTable } from "./UseElementosEstandarTable";
import { PanelNuevoElemento } from "./nuevoElemento/PanelNuevoElemento";
import { PanelEditarElemento } from "./editarElemento/PanelEditarElemento";
import { PanelOcutarElemento } from "./ocultoElemento/PanelOcultarElemento";


export const ElementosEstandarTable=()=>{
    const { items, filter, setFilter, loading, pagination, onChangeSearch, getElementos, handleResetUpdate, onChangeTake, _onkeyUpSearchTable } = UseElementosEstandarTable()
    const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
    const [isOpenNuevo, { setTrue: openPanelNuevo ,setFalse: closePanelNuevo }] = useBoolean(false);
    const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
    const [item, setItem] = useState<IElementoEstandarDTO>({
        elementoEstandarId: "",
        nombreElementoEstandar: "",
        codigoElementoEstandar: "",
        esOculto:false
    })
    const buttonLeft: ICommandBarItemProps[] = [
        {
          ...IconHelper.ICON_ADD_TABLE,
          text: "Nuevo",
          onClick: openPanelNuevo,
       },
       {
         ...IconHelper.ICON_RELOAD,
         text: "Actualizar",
         onClick: () => {
           handleResetUpdate()
         },
       }
     ];
     const _columns = [
        {
          key: "nombreElementoEstandar",
          name: "Elemento Estandar",
          fieldName: "nombreElementoEstandar",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          key: "codigoElementoEstandar",
          name: "Codigo",
          fieldName: "codigoElementoEstandar",
          minWidth: 100,
          maxWidth: 300,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 100,
            maxWidth: 300,
            onRender: (item: IElementoEstandarDTO) => renderOpciones(item)
          }
    ]
    function renderOpciones(item: IElementoEstandarDTO) {
        return (
            <>
              <TooltipHost content={"Editar"}>
                <Icon
                  iconName="Edit"
                  className={themeBase.classNamesIcon.iconFont}
                  style={{ cursor: "pointer", color: "#0078d3" }}
                  onClick={() => {
                    setItem(item)
                    openPanelEditar()
                  }}
                />
              </TooltipHost>
              {item.esOculto ? (<TooltipHost content={"Integrar"}>
                 <Icon
                   iconName="Add"
                   className={themeBase.classNamesIcon.iconFont}
                   style={{ cursor: "pointer", color: "#0078d3" }}
                   onClick={() => {
                     setItem(item)
                     openPanelEliminar()
                   }}
                 />
              </TooltipHost>):(
                 <TooltipHost content={"Ocultar"}>
                 <Icon
                   iconName="Delete"
                   className={themeBase.classNamesIcon.iconFont}
                   style={{ cursor: "pointer", color: "#0078d3" }}
                   onClick={() => {
                     setItem(item)
                     openPanelEliminar()
                   }}
                 />
               </TooltipHost>
              )}
             
            </>
          );
    }
    return (
        <>
        <CabeceraTable
        Titulo={"Elementos Estandar"}
        SubTitulo={"Gestión de Elementos Estandar"}
        onKeyUp={_onkeyUpSearchTable}
        />
        <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
        />
        <PanelNuevoElemento isOpen={isOpenNuevo} onDismiss={closePanelNuevo} reload={handleResetUpdate}/>
        <PanelEditarElemento item={item} isOpen={isOpenEditar} onDismiss={closePanelEditar} reload={handleResetUpdate} />
        <PanelOcutarElemento item={item} isOpen={isOpenEliminar} onDismiss={closePanelEliminar} reload={handleResetUpdate}/>
        </>
    )
}